import Kpi, {kpiDescription} from "../../performance/Kpi";
import React from "react";

import styled from "styled-components";
import PerformanceValue from "../../performance/PerformanceValue";
import Metric, {MetricValue} from "./Metric";

const KpiSymbol = styled.div`
    margin-top: 2px;
`;

const KpiContainer = styled.div`
    display: flex;
    align-items: center;
`;

const KpiMetric = ({kpiName, kpiValue, currency}) => (
    <Metric label={kpiDescription(kpiName, currency)}>
        <KpiContainer>
            <MetricValue>
                <PerformanceValue name={kpiName} value={kpiValue}/>
            </MetricValue>
            <KpiSymbol>
                <Kpi>KPI</Kpi>
            </KpiSymbol>
        </KpiContainer>
    </Metric>
);

export default KpiMetric;
